<mat-drawer-container [hasBackdrop]="tabletQuery.matches" class="page-height">
  <mat-drawer-content
    class="ml-0 bg-panel page-height d-flex justify-content-between align-items-center flex-column p-md-2"
  >
    <div
      class="d-flex justify-content-between align-items-center flex-row py-3 px-4 w-100 shadow main-panel"
      style="z-index: 10"
    >
      <button
        mat-icon-button
        color="primary"
        class="rounded-circle shadow-sm border border-1 border-primary"
        style="
          width: 40px;
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
        "
        (click)="refreshTransactions()"
        data-test="transactions-refresh-btn"
        [matTooltip]="'Refresh'"
      >
        <mat-icon fontIcon="refresh" style="font-size: 24px">refresh</mat-icon>
      </button>
    </div>

    <mat-divider></mat-divider>

    <div class="w-100 h-100 flex-fill overflow-auto">
      @if (loading) {
        <div
          class="interactive main-panel px-3 py-3 d-flex flex-row justify-content-between align-items-center gap-4 opacity-75"
        >
          <span class="flex-grow-1 flex-shrink-0"
            >Getting new crypto transactions... Please wait...</span
          >
        </div>
        <mat-divider></mat-divider>
      }

      @for (tx of cryptoTransactions; track tx) {
        <div
          class="interactive main-panel px-3 py-3 transaction-grid"
          (click)="openTransactionDetails(tx)"
        >
          <span [matTooltip]="tx.currency">
            @if (tx.currency === 'BTC') {
              <mat-icon>currency_bitcoin</mat-icon>
            } @else {
              <mat-icon>currency_exchange</mat-icon>
            }
          </span>
          <span [matTooltip]="tx.state">
            @switch (tx.state) {
              @case ('confirmed') {
                <mat-icon color="primary" class="text-success">
                  check_circle
                </mat-icon>
              }
              @case ('cancelled') {
                <mat-icon color="warn" class="text-danger"> cancel </mat-icon>
              }
              @default {
                <mat-icon color="warn" class="text-warning">
                  hourglass_empty
                </mat-icon>
              }
            }
          </span>
          <span>{{ tx.createDate | date: 'dd-MM-yyyy HH:mm' }}</span>
          <span>{{ tx.invoiceAmount | currency: tx.invoiceCurrency }}</span>
          <!-- Preserve column structure -->
          <span>
            <span class="d-none d-sm-inline"
              >{{ tx.amount }} {{ tx.currency }}</span
            >
          </span>
          <mat-icon class="transaction-chevron">chevron_right</mat-icon>
        </div>
      }

      <ng-template #noData>
        @if (!loading) {
          <div
            class="interactive main-panel px-3 py-3 d-flex flex-row justify-content-between align-items-center gap-4 opacity-50"
          >
            <span class="flex-grow-1 flex-shrink-0">No Data</span>
          </div>
          <mat-divider></mat-divider>
        }
      </ng-template>
    </div>
  </mat-drawer-content>
</mat-drawer-container>
